import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Toggle } from "@ts-digital/vrc";
import { Input, Select, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import NumberFormat from "react-number-format";
import { useDispatch, useSelector } from "react-redux";
import { getCountriesList, getDeliveryTermsList, getDeliveyModeList, getTransactionAList, getTransactionBList, updateDrawerFields } from "../../../../../store/actions/precog/intrastat";
import VaporFormItem from "../../../../vapor/form";
import { referenceFrequency, referencePeriod } from "../mockedDrawer";
import "../style.css";

const Option = Select.Option;

const GoodsDrawer = ({ isSaleInvoice, draftId, id, model }) => {

  // !newDetail?.doc?.active

  const dispatch = useDispatch();
  const transactionsCodeAList = useSelector(state => state.intrastatDrawer.transactionsCodeA?.list);
  const transactionsCodeBList = useSelector(state => state.intrastatDrawer.transactionsCodeB?.list);
  const deliveryTermsList = useSelector(state => state.intrastatDrawer.deliveryTerms?.list);
  const deliveryModeList = useSelector(state => state.intrastatDrawer.deliveryMode?.list);
  const countriesList = useSelector(state => state.intrastatDrawer.countries?.list);

  const [selections, setSelections] = useState({
    triangulation: false,
    provinciaOrigine: undefined,
    transactionCodeA: undefined,
    transactionCodeB: undefined,
    unitWeight: undefined,
    additionalUnit: undefined,
    euroStatisticalAmount: undefined,
    deliveryTerms: undefined,
    deliveryMode: undefined,
    destinationCountry: undefined,
    originProvince: undefined,
    referenceFrequency: undefined,
    referencePeriod: undefined,
    destinationProvince: undefined,
    rectification: false,
    originCountry: undefined,
    shipmentOriginCountry: undefined
  });
  const [transactionCodeAOptions, setTransactionCodeAOptions] = useState([]);
  const [transactionCodeBOptions, setTransactionCodeBOptions] = useState([]);
  const [deliveryTermsOptions, setDeliveryTermsOptions] = useState([]);
  const [deliveryModeOptions, setDeliveryModeOptions] = useState([]);
  const [countriesOptions, setCountriesOptions] = useState([]);

  useEffect(() => {
    dispatch(getTransactionAList());
    dispatch(getDeliveryTermsList());
    dispatch(getDeliveyModeList());
    dispatch(getCountriesList());
  }, []);

  useEffect(() => {
    if (!selections.transactionCodeA) return;
    dispatch(getTransactionBList(selections.transactionCodeA));
  }, [selections.transactionCodeA]);

  useEffect(() => {
    if (!transactionsCodeAList) return;
    let newList = [];
    transactionsCodeAList.map(el => {
      if (selections.triangulation) {
        newList.push({code: el.telematicCodeWithTriangulation, description: el.description});
      } else {
        newList.push({code: el.telematicCodeWithoutTriangulation, description: el.description});
      }
      return newList;
    });
    setTransactionCodeAOptions(newList);
  }, [transactionsCodeAList, selections.triangulation]);

  useEffect(() => {
    if (!transactionsCodeBList) return;
    setTransactionCodeBOptions(transactionsCodeBList);
  }, [transactionsCodeBList]);

  useEffect(() => {
    if (!deliveryTermsList) return;
    setDeliveryTermsOptions(deliveryTermsList);
  }, [deliveryTermsList]);

  useEffect(() => {
    if (!deliveryModeList) return;
    setDeliveryModeOptions(deliveryModeList);
  }, [deliveryModeList]);

  useEffect(() => {
    if (!countriesList) return;
    setCountriesOptions(countriesList);
  }, [countriesList]);
  
  useEffect(() => {
    if (!model) return;
    setSelections({
      triangulation: model.triangulation,
      transactionCodeA: model.triangulation ? model.transactionCodeA : model.transactionCodeA ? parseInt(model.transactionCodeA) : undefined,
      transactionCodeB: model.transactionCodeB ? parseInt(model.transactionCodeB) : undefined,
      unitWeight: model.unitWeight,
      additionalUnit: model.additionalUnit,
      euroStatisticalAmount: model.euroStatisticalAmount,
      deliveryTerms: model.deliveryTerms,
      deliveryMode: model.deliveryMode,
      destinationCountry: model.destinationCountry,
      originProvince: model.originProvince,
      referenceFrequency: model.referenceFrequency,
      referencePeriod: model.referencePeriod,
      destinationProvince: model.destinationProvince,
      rectification: model.rectification,
      originCountry: model.originCountry,
      shipmentOriginCountry: model.shipmentOriginCountry
    });
  }, [model]);

  const onFieldChange = (fieldToChange) => {
    dispatch(updateDrawerFields(
      draftId, id, fieldToChange
    ));
  };
  
  return (
    <div className="dbx-preCog-intrastat-add-nomenclatura-content">
      <div style={{display: "flex", justifyContent: "space-between"}}>
        <div className="dbx-preCog-intrastat-add-nomenclatura-row">
          <FormattedMessage id="preCog.intrastatTab.triangulation" /> <span>
            <Toggle
              checked={selections.triangulation}
              onChange={() => {
                setSelections({ ...selections, triangulation: !selections.triangulation });
                onFieldChange({ triangulation: !selections.triangulation });
              }}
            /></span> <FontAwesomeIcon className="preCog-intrastat-drawer-info-circle-icon" icon={["fas", "info-circle"]} />
        </div>
        <div className="dbx-preCog-intrastat-add-nomenclatura-row">
          Rettifica <span>
            <Toggle
              checked={selections.rectification}
              onChange={() => {
                setSelections({ ...selections, rectification: !selections.rectification });
                onFieldChange({ rectification: !selections.rectification });
              }}
            /></span> <FontAwesomeIcon className="preCog-intrastat-drawer-info-circle-icon" icon={["fas", "info-circle"]} />
        </div>
      </div>
      {selections.rectification && <>
        <div>
          <div><VaporFormItem
            label={<>
              <div className="intrastat-form-label">
                <FormattedMessage id="preCog.intrastatTab.referenceFrequency"/> *
              </div>
              <div><FontAwesomeIcon className="preCog-intrastat-drawer-info-circle-icon" icon={["fas", "info-circle"]} /></div></>}>
            <Select
              showSearch
              optionFilterProp="children"
              getPopupContainer={trigger => trigger.parentNode}
              filterOption={(input, option) => 
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              onSelect={value => {
                setSelections({ ...selections, referenceFrequency: value });
                onFieldChange({ referenceFrequency: value });
              }}
              style={{width: "100%"}}
              value={selections.referenceFrequency}
              placeholder="Seleziona periodicità"
            >
              {referenceFrequency.map((el, index) => (
                <Option key={`referenceFrequency_${index}`} value={el.id}>
                  {el.description}
                </Option>
              ))}
            </Select>
          </VaporFormItem>
          </div>
        </div>
        <div>
          <div><VaporFormItem
            label={<>
              <div className="intrastat-form-label">
                <FormattedMessage id="preCog.intrastatTab.referencePeriod"/> *
              </div>
              <div><FontAwesomeIcon className="preCog-intrastat-drawer-info-circle-icon" icon={["fas", "info-circle"]} /></div></>}>
            <Select
              showSearch
              optionFilterProp="children"
              getPopupContainer={trigger => trigger.parentNode}
              filterOption={(input, option) => 
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              onSelect={value => {
                setSelections({ ...selections, referencePeriod: value });
                onFieldChange({ referencePeriod: value });
              }}
              style={{width: "100%"}}
              value={selections.referencePeriod}
              placeholder="Seleziona periodo di riferimento"
            >
              {referencePeriod.map((el, index) => (
                <Option key={`referencePeriod_${index}`} value={el.id}>
                  {el.description}
                </Option>
              ))}
            </Select>
          </VaporFormItem>
          </div>
        </div>
      </>}
      <div>
        <div className="intrastat-transactions" style={{display: "flex", gap: 24}}>
          <VaporFormItem
            label={<>
              <div className="intrastat-form-label">
                <FormattedMessage id="preCog.intrastatTab.transactionCodeA"/>
              </div>
              <div><FontAwesomeIcon className="preCog-intrastat-drawer-info-circle-icon" icon={["fas", "info-circle"]} /></div></>
            }>
            <Select
              showSearch
              optionFilterProp="children"
              getPopupContainer={trigger => trigger.parentNode}
              filterOption={(input, option) => 
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              style={{width: "100%"}}
              value={selections.transactionCodeA}
              placeholder="Seleziona natura"
              onSelect={value => {
                setSelections({ ...selections, transactionCodeA: value, transactionCodeB: undefined });
                onFieldChange({ transactionCodeA: value, transactionCodeB: "" });
              }}
            >
              {transactionCodeAOptions.map((el, index) => {
                return <Option
                  key={`transactionCodeA_${index}`}
                  value={el.code}
                >
                  {el.description}
                </Option>;
              })}
            </Select>
          </VaporFormItem>
          {!selections.triangulation && <VaporFormItem
            label={<>
              <div className="intrastat-form-label">
                <FormattedMessage id="preCog.intrastatTab.transactionCodeB"/>
              </div>
              <div><FontAwesomeIcon className="preCog-intrastat-drawer-info-circle-icon" icon={["fas", "info-circle"]} /></div></>
            }>
            <Select
              showSearch
              optionFilterProp="children"
              getPopupContainer={trigger => trigger.parentNode}
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              style={{ width: "100%" }}
              value={selections.transactionCodeB}
              placeholder="Seleziona natura"
              onSelect={value => {
                setSelections({ ...selections, transactionCodeB: value });
                onFieldChange({ transactionCodeB: value });
              }}
            >
              {transactionCodeBOptions.map((el, index) => {
                return <Option key={`transactionCodeB_${index}`} value={el.code}>
                  {el.description}
                </Option>;
              })}
            </Select>
          </VaporFormItem>}
        </div>
      </div>
      {!selections.rectification && <><div>
        <div><VaporFormItem
          label={<>
            <div className="intrastat-form-label">
              <FormattedMessage id="preCog.intrastatTab.unitWeight" />
            </div>
            <div>
              <Tooltip
                placement="left"
                title={<FormattedMessage id="preCog.intrastatTab.tooltips.unitWeight" />}
                color={"#005075"}
              >
                <FontAwesomeIcon className="preCog-intrastat-drawer-info-circle-icon" icon={["fas", "info-circle"]} />
              </Tooltip>
            </div></>}>
          <NumberFormat
            id="pre-cog-detail-input-8"
            displayType={"input"}
            thousandSeparator={"."}
            decimalScale={0}
            decimalSeparator={","}
            className={"nomenclatura-input"}            
            value={selections.unitWeight !== 0 ? numeral(selections.unitWeight).format("0,0.00") : null}
            onValueChange={e => {
              setSelections({
                ...selections,
                unitWeight: e.value
              });
              onFieldChange({unitWeight: e.value});
            }}
            placeholder="- Kg"
            suffix={"kg"}
          />
        </VaporFormItem>
        </div>
      </div>
      <div>
        <div><VaporFormItem
          label={<>
            <div className="intrastat-form-label">
              <FormattedMessage id="preCog.intrastatTab.additionalUnit" />
            </div>
            <div><FontAwesomeIcon className="preCog-intrastat-drawer-info-circle-icon" icon={["fas", "info-circle"]} /></div></>}>
          <NumberFormat
            id="pre-cog-detail-input-8"
            displayType={"input"}
            thousandSeparator={"."}
            decimalScale={0}
            decimalSeparator={","}
            className={"nomenclatura-input"}
            value={selections.additionalUnit}
            onValueChange={e => {
              setSelections({
                ...selections,
                additionalUnit: e.value
              });
              onFieldChange({additionalUnit: e.value});
            }}
            placeholder="Unità misura supplementare"
          />
        </VaporFormItem>
        </div>
      </div></>}
      <div>
        <div><VaporFormItem
          label={<>
            <div className="intrastat-form-label">
              <FormattedMessage id="preCog.intrastatTab.euroStatisticalAmount" />
            </div>
            <div>
              <Tooltip
                placement="left"
                title={<FormattedMessage id="preCog.intrastatTab.tooltips.euroStatisticalAmount" />}
                color={"#005075"}
              >
                <FontAwesomeIcon className="preCog-intrastat-drawer-info-circle-icon" icon={["fas", "info-circle"]} />
              </Tooltip>
            </div></>}>
          <NumberFormat
            id="pre-cog-detail-input-8"
            displayType={"input"}
            thousandSeparator={"."}
            decimalScale={0}
            decimalSeparator={","}
            className={"nomenclatura-input"}
            value={selections.euroStatisticalAmount}
            onValueChange={e => {
              setSelections({
                ...selections,
                euroStatisticalAmount: e.value
              });
              onFieldChange({euroStatisticalAmount: e.value});
            }}
            placeholder="- €"
            suffix={"€"}
          />
        </VaporFormItem>
        </div>
      </div>
      {!selections.rectification && <><div>
        <div><VaporFormItem
          label={<>
            <div className="intrastat-form-label">
              <FormattedMessage id="preCog.intrastatTab.deliveryTerms" />
            </div>
            <Tooltip
              placement="left"
              title={<FormattedMessage id="preCog.intrastatTab.tooltips.deliveryTerms" />}
              color={"#005075"}
            >
              <div><FontAwesomeIcon className="preCog-intrastat-drawer-info-circle-icon" icon={["fas", "info-circle"]} /></div>
            </Tooltip>
          </>}>
          <Select
            showSearch
            optionFilterProp="children"
            getPopupContainer={trigger => trigger.parentNode}
            filterOption={(input, option) => 
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            onSelect={value => {
              setSelections({ ...selections, deliveryTerms: value });
              onFieldChange({deliveryTerms: value});
            }}
            style={{width: "100%"}}
            value={selections.deliveryTerms}
            placeholder="Seleziona condizioni di consegna"
          >
            {deliveryTermsOptions.map((el, index) => (
              <Option key={`deliveryTerms_${index}`} value={el.code}>
                {el.description}
              </Option>
            ))}
          </Select>
        </VaporFormItem>
        </div>
      </div>
      <div>
        <div><VaporFormItem
          label={<>
            <div className="intrastat-form-label">
              <FormattedMessage id="preCog.intrastatTab.deliveryMode" />
            </div>
            <div>
              <Tooltip
                placement="left"
                title={<FormattedMessage id="preCog.intrastatTab.tooltips.deliveryMode" />}
                color={"#005075"}
              >
                <FontAwesomeIcon className="preCog-intrastat-drawer-info-circle-icon" icon={["fas", "info-circle"]} />
              </Tooltip></div></>}>
          <Select
            showSearch
            optionFilterProp="children"
            getPopupContainer={trigger => trigger.parentNode}
            filterOption={(input, option) => 
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            onSelect={value => {
              setSelections({ ...selections, deliveryMode: value });
              onFieldChange({deliveryMode: value});
            }}
            style={{width: "100%"}}
            value={selections.deliveryMode}
            placeholder="Seleziona modalità di trasporto"
          >
            {deliveryModeOptions.map((el, index) => (
              <Option key={`deliveryMode_${index}`} value={el.code}>
                {el.description}
              </Option>
            ))}
          </Select>
        </VaporFormItem>
        </div>
      </div>
      <div>
        <div><VaporFormItem
          label={<>
            <div className="intrastat-form-label">
              <FormattedMessage id={isSaleInvoice ? "preCog.intrastatTab.destinationCountry" : "preCog.intrastatTab.shipmentOriginCountry"} />
            </div>
            <div>
              <Tooltip
                placement="left"
                title={<FormattedMessage id={`preCog.intrastatTab.tooltips.${isSaleInvoice ? "destinationCountry" : "shipmentOriginCountry"}`} />}
                color={"#005075"}
              >
                <FontAwesomeIcon className="preCog-intrastat-drawer-info-circle-icon" icon={["fas", "info-circle"]} />
              </Tooltip></div></>}>
          <Select
            showSearch
            optionFilterProp="children"
            getPopupContainer={trigger => trigger.parentNode}
            filterOption={(input, option) => 
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            onSelect={value => {
              setSelections(isSaleInvoice ? { ...selections, destinationCountry: value } : {...selections, shipmentOriginCountry: value});
              onFieldChange(isSaleInvoice ? {destinationCountry: value} : {shipmentOriginCountry: value});
            }}
            style={{width: "100%"}}
            value={isSaleInvoice ?  selections.destinationCountry : selections.shipmentOriginCountry}
            placeholder="Seleziona paese di destinazione"
          >
            {countriesOptions.map((el, index) => (
              <Option key={`destinationCountry_${index}`} value={el.isoCode}>
                {el.countryName}
              </Option>
            ))}
          </Select>
        </VaporFormItem>
        </div>
      </div>
      <div>
        <div><VaporFormItem
          label={<>
            <div className="intrastat-form-label">
              <FormattedMessage id={isSaleInvoice ? "preCog.intrastatTab.originProvince" : "preCog.intrastatTab.originCountry"} />
            </div>
            <div>
              <Tooltip
                placement="left"
                title={<FormattedMessage id={`preCog.intrastatTab.tooltips.${isSaleInvoice ? "originProvince" : "originCountry"}`} />}
                color={"#005075"}
              >
                <FontAwesomeIcon className="preCog-intrastat-drawer-info-circle-icon" icon={["fas", "info-circle"]} />
              </Tooltip>
            </div></>}>
          {isSaleInvoice ? <Input
            value={selections.originProvince}
            className="nomenclatura-input"
            onChange={(e) =>
              setSelections({ ...selections, originProvince: e.target.value })
            }
            onBlur={() => onFieldChange({ originProvince: selections.originProvince })}
          /> :
            <Select
              showSearch
              optionFilterProp="children"
              getPopupContainer={trigger => trigger.parentNode}
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              onSelect={value => {
                setSelections({ ...selections, originCountry });
                onFieldChange({ originCountry: value });
              }}
              style={{ width: "100%" }}
              value={selections.originCountry}
              placeholder="Seleziona paese"
            >
              {countriesOptions.map((el, index) => (
                <Option key={`destinationCountry_${index}`} value={el.isoCode}>
                  {el.countryName}
                </Option>
              ))}
            </Select>}
        </VaporFormItem>
        </div>
      </div>
      {!isSaleInvoice && <div>
        <div><VaporFormItem
          label={<>
            <div className="intrastat-form-label">
              <FormattedMessage id="preCog.intrastatTab.provinceDestination" />
            </div>
            <div>
              <Tooltip
                placement="left"
                title={<FormattedMessage id={"preCog.intrastatTab.tooltips.destinationProvince"} />}
                color={"#005075"}
              >
                <FontAwesomeIcon className="preCog-intrastat-drawer-info-circle-icon" icon={["fas", "info-circle"]} />
              </Tooltip>
            </div></>}>
          <Input
            style={{fontSize: 14}}
            value={selections.destinationProvince}
            className="nomenclatura-input"
            placeholder="Inserisci la provincia"
            onChange={(e) =>
              setSelections({...selections, destinationProvince: e.target.value})
            }
            onBlur={() => onFieldChange({destinationProvince: selections.destinationProvince})}
          />
        </VaporFormItem>
        </div>
      </div>}
      </>}
    </div>
  );
};

export default GoodsDrawer;
